import React from 'react'
import { PaperLoanUI } from '../../components/PaperLoanUI'

export function PaperLoanLedgerPage() {
  return (
    <div className="min-h-screen">
      <PaperLoanUI />
    </div>
  )
}
